module.exports = __webpack_public_path__ + "96c4c2cd8b8076eac590e2aae0869ae2.svg";